export default __webpack_public_path__ + "static/media/card.f446b06d.svg";